import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-shield-user-line',
    title: 'Armed Security Officers',
    description: 'Highly trained armed security professionals providing maximum protection for high-risk environments and valuable assets.',
  },
  {
    icon: 'ri-user-line',
    title: 'Unarmed Security Officers',
    description: 'Professional unarmed security personnel offering visible deterrence and customer-friendly protection services.',
  },
  {
    icon: 'ri-calendar-event-line',
    title: 'Event Security',
    description: 'Specialized event security teams ensuring safe and smooth operations for gatherings of all sizes.',
  },
  {
    icon: 'ri-car-line',
    title: 'Patrol & Mobile Surveillance',
    description: 'Mobile patrol units providing comprehensive coverage and rapid response across multiple locations.',
  },
  {
    icon: 'ri-building-line',
    title: 'Construction Site Security',
    description: 'Dedicated security solutions protecting construction sites, equipment, and materials around the clock.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Loss Prevention Security',
    description: 'Strategic loss prevention services minimizing theft and protecting your bottom line through proven methods.',
  },
];

const ServicesSection = () => {
  return (
    <section className="py-20 bg-dark-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary-400 font-semibold text-sm uppercase tracking-wider">
            Comprehensive Security Solutions
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6 font-display">
            Elite Security Staffing
          </h2>
          <p className="text-dark-300 text-lg max-w-3xl mx-auto">
            With a proven record of excellence, years of industry knowledge and expertise, we deliver private security services that balance visibility, discretion, and readiness.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-dark-800 border border-dark-700 rounded-lg p-8 hover:border-primary-500 transition-all hover:transform hover:scale-105 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-primary-500/10 rounded-lg mb-6 group-hover:bg-primary-500 transition-colors">
                <i className={`${service.icon} text-3xl text-primary-400 group-hover:text-dark-900`}></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">{service.title}</h3>
              <p className="text-dark-300 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center px-8 py-4 bg-primary-500 text-dark-900 rounded-lg text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Services
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;